var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    perPage
  } = options;

__p+='\n\n\n<div class="rates-per-page float-right">\n  <select class="form-control selectpicker js-rates-per-page">\n    <option value="10" '+
((__t=( perPage == '10' ? 'selected' : null ))==null?'':__t)+
'>10</option>\n    <option value="20" '+
((__t=( perPage == '20' ? 'selected' : null ))==null?'':__t)+
'>20</option>\n    <option value="50" '+
((__t=( perPage == '50' ? 'selected' : null ))==null?'':__t)+
'>50</option>\n  </select>\n  <span>rates per page</span>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_rates_per_page.jst.ejs